<template>
    <div>
        <common-content-spacer height="small">
            <div v-for="(option, index) of options" :key="index" class="availability-month-calendar-slot__container">
                <div v-clickaway="closeContextMenu" :class="slotClass(option.value)">
                    {{ option.label }}
                    <div class="referral-context-menu referral-context-menu--availability">
                        <referral-context-menu
                            v-if="getReferralContextMenuKey(dayPeriod, index) === presentedContextMenuKey"
                            :optionProp="option"
                            :showCancelled="showCancelled"
                            @closeReferralContextMenu="closeContextMenu"
                            @schedule-changed="emitEvent({ name: 'schedule-changed' })"
                        ></referral-context-menu>
                        <common-icon
                            :name="dotsIcon(option.value.referral)"
                            size="medium"
                            @click="openContextMenu($event, index)"
                        ></common-icon>
                    </div>
                </div>
                <span v-if="checkIfActionNeeded(option.value)" class="availability-month-calendar-slot__action-dot"></span>
            </div>
        </common-content-spacer>
    </div>
</template>

<script>
    import ReferralContextMenu from '../ReferralContextMenu'
    import ReferralContextMenuMixin from 'mixins/ReferralContextMenuMixin'
    import ReferralStatusMixin from 'mixins/ReferralStatusMixin'
    import ReferralStatusEnum from '../../../enums/ReferralStatusEnum'

    export default {
        mixins: [ReferralContextMenuMixin, ReferralStatusMixin],

        components: {
            ReferralContextMenu,
        },

        props: {
            dayPeriod: { type: String, required: false, default: undefined },
            presentedContextMenuKey: { type: String, required: true, default: '' },
            options: { type: Array, required: true },
            showCancelled: { type: Boolean, required: true },
        },

        methods: {
            dotsIcon(referral) {
                if (!referral || (this.isReferralCancelledOrNoShow(referral) && !this.showCancelled)) return 'dots-dark'
                return 'dots-white'
            },

            slotClass(optionValue) {
                let referral = optionValue.referral
                return {
                    'referral-context-menu-wrapper': true,
                    'availability-month-calendar-slot': true,
                    'availability-month-calendar-slot--pending': this.isReferralPendingOrReschedule(referral),
                    'availability-month-calendar-slot--completed': this.isReferralCompleted(referral),
                    'availability-month-calendar-slot--confirmed': this.isReferralOk(referral),
                    'availability-month-calendar-slot--cancelled':
                        this.isReferralCancelledOrNoShow(referral) && this.showCancelled,
                    'availability-month-calendar-slot--unavailable': !referral && optionValue.isUnavailable,
                }
            },

            checkIfActionNeeded(slot) {
                return (
                    slot.referral &&
                    (slot.referral.status === ReferralStatusEnum.CREATED ||
                        slot.referral.status === ReferralStatusEnum.INSURANCE_AUTH_PENDING ||
                        slot.referral.status === ReferralStatusEnum.CONSULTATION_NOTES_PENDING)
                )
            },

            openContextMenu(event, index) {
                const payload = {
                    originalEvent: event,
                    key: this.getReferralContextMenuKey(this.dayPeriod, index),
                }
                this.emitEvent({ name: 'toggleSlot', payload: payload })
            },

            closeContextMenu(event) {
                const payload = {
                    originalEvent: event,
                    key: '',
                }
                this.emitEvent({ name: 'toggleSlot', payload: payload })
            },
        },
    }
</script>
